import React, { useState, useMemo } from 'react'

import i18n from 'i18next'

import {
  Tabs,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, array, string } from 'prop-types'


import AdditionalContent from './Components/AdditionalContent/AdditionalContent'

function AdditionalItems({
  isCartBelowThreshold,
  isCartAboveThreshold,
  shouldShowCartProgress,
  cartItems,
  locale = 'en',
}) {
  const [selectedTab, setSelectedTab] = useState('wishlist-tab')

  const cartItemIds = cartItems.map((item) => item.relationships.item.data.id)

  const tabs = useMemo(() => [{
    id: 'wishlist-tab',
    title: i18n.t('navigation.cart_widget.wishlist_tab', { ns: 'rails', lng: locale }),
  }, {
    id: 'recently-viewed-tab',
    title: i18n.t('navigation.cart_widget.recently_viewed_tab', { ns: 'rails', lng: locale }),
  }], [locale])

  return (
    <div className="nav-options-dropdown__section">
      <Tabs
        onClick={(id) => setSelectedTab(id)}
        activeTabId={selectedTab}
        tabs={tabs}
        size="small"
        displaySeparator
        expand
      />
      <AdditionalContent
        variation={selectedTab}
        isCartBelowThreshold={isCartBelowThreshold}
        isCartAboveThreshold={isCartAboveThreshold}
        shouldShowCartProgress={shouldShowCartProgress}
        cartItemIds={cartItemIds}
        locale={locale}
      />
    </div>
  )
}

AdditionalItems.propTypes = {
  isCartBelowThreshold: bool.isRequired,
  isCartAboveThreshold: bool.isRequired,
  shouldShowCartProgress: bool.isRequired,
  cartItems: array.isRequired,
  locale: string,
}


export default AdditionalItems
